import { usingGet, usingPost, createProxyUrl } from '@ocean/api'
import { SessionUtils } from '@ocean/utils'
import { BASE_API_SCHEDULE_PATH } from 'modules/virtualClassrooms/common/helpers'
import { ApiSetTaskStatusParams } from 'modules/virtualClassrooms/student/ParticipantScheduleDetails/types'

export const getScheduleDetailsForParticipant = (scheduleId: Guid) =>
  usingGet(`${BASE_API_SCHEDULE_PATH}/${scheduleId}/participant`, { useProxy: true })

export const setEventTaskStatus = (params: ApiSetTaskStatusParams) =>
  usingPost('virtualevents/SetVirtualEventTaskStatus', params)

export const createTaskFileDownloadUrl = (taskId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`virtualevents/taskfile?taskId=${taskId}&token=${sessionToken}`)
}

export const createPresentationFileDownloadUrl = (fileId: string) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(`virtualevents/presentationfile?fileId=${fileId}&token=${sessionToken}`)
}

export const startVirtualEvent = (scheduleId: Guid) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/join`, { scheduleId }, { useProxy: true })
